import React from 'react';
import { Divider } from '@alifd/next';

export default ({cotent,style}) => {
  // 蓝色感叹号 + 文字（注意事项等）
  return (
    <section style={style}>
      <div style={{color:'#333333',display:'flex',flexDirection:'row'}}>
        <span className={`iconfont icon-icon4-38`} style={{ fontSize: '16px', color: "rgb(51, 153, 255)",marginRight: 10,verticalAlign: 'middle' }}></span>
        <div style={{fontSize:12,fontWeight:500}}>
          {cotent}
        </div>
      </div>
    </section>
  );
};
